import React from 'react';

import { IconArrowLeft, IconArrowRight } from '@xingternal/icons';

import * as S from './pagination.styles';

type PaginationProps = {
  children: React.ReactNode;
  prevLink?: string;
  nextLink?: string;
  hidePrevArrow?: boolean;
  hideNextArrow?: boolean;
  onNext?: () => void;
  onPrev?: () => void;
};

export const Pagination: React.FC<PaginationProps> = ({
  children,
  prevLink,
  nextLink,
  hidePrevArrow,
  hideNextArrow,
  onNext,
  onPrev,
}) => {
  return (
    <nav>
      <S.Pagination>
        <li>
          <S.ArrowLink $hidden={hidePrevArrow} href={prevLink} onClick={hidePrevArrow ? undefined : onPrev}>
            <IconArrowLeft width={24} height={24} />
          </S.ArrowLink>
        </li>
        {children}
        <li>
          <S.ArrowLink $hidden={hideNextArrow} href={nextLink} onClick={hideNextArrow ? undefined : onNext}>
            <IconArrowRight width={24} height={24} />
          </S.ArrowLink>
        </li>
      </S.Pagination>
    </nav>
  );
};
